"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENTS = void 0;
exports.DOCUMENTS = {
    INVALID_DOCUMENT_CREATION: {
        usecase: "DOCUMENTS",
        type: "INVALID_DOCUMENT_CREATION",
        messageLangMap: {
            "PT-BR": "Já existe um documento desse tipo cadastrado.",
            "EN-US": "A document of this type is already registered.",
        },
    },
};
